import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import {
  isEEARegion,
  getStoredAnalyticsConsent,
  setAnalyticsConsent,
} from '@/lib/firebase';
import { initOaiq } from '@/lib/oaiq';
import { initMetaPixel } from '@/lib/metaPixel';

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isEEARegion()) {
      // EEA/UK: show until the user explicitly accepts or rejects
      const stored = getStoredAnalyticsConsent();
      if (!stored) setVisible(true);
    }
    // Non-EEA: no banner needed - analytics auto-granted in initAnalytics(),
    // privacy policy accessible via footer. Avoids UX friction in in-app
    // browsers (e.g. Instagram) where localStorage doesn't persist.
  }, []);

  const accept = () => {
    void setAnalyticsConsent(true);
    // The ads pixel refused to load while consent was unresolved; now that it
    // is granted, bring it up in this same session rather than the next one.
    initOaiq();
    initMetaPixel();
    setVisible(false);
  };

  const reject = () => {
    void setAnalyticsConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 pointer-events-none">
      <div className="max-w-2xl mx-auto pointer-events-auto">
        <div className="flex items-center gap-4 px-5 py-3.5 rounded-xl border border-white/10 bg-black/90 backdrop-blur-md shadow-2xl">
          <p className="text-sm text-gray-300 flex-1">
            We use essential cookies for authentication and payments. With your
            consent, we also use Firebase Analytics to understand how the Service
            is used, and advertising measurement pixels to see which ads lead to
            a purchase.{' '}
            <Link
              to="/privacy"
              className="text-primary-400 hover:text-primary-300 underline"
            >
              Privacy Policy
            </Link>
          </p>
          <button
            onClick={reject}
            className="shrink-0 px-4 py-1.5 text-sm font-medium text-white bg-white/5 hover:bg-white/10 rounded-lg border border-white/10 transition-colors"
          >
            Reject
          </button>
          <button
            onClick={accept}
            className="shrink-0 px-4 py-1.5 text-sm font-medium text-white bg-primary-600 hover:bg-primary-500 rounded-lg border border-primary-500/50 transition-colors"
          >
            Accept
          </button>
          <button
            onClick={reject}
            className="shrink-0 text-gray-500 hover:text-white transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
